import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import "./addresurs.css";
import { Link, useNavigate } from "react-router-dom";

const AddResurs = ({ user, API_URL }) => {





    const [nameTours, setnameTours] = useState(null);
    const [nameCompany, setnameCompany] = useState(null);
    const [innCompany, setInnCompany] = useState("");
    const [nameGuide, setnameGuide] = useState(null);
    const [nameCafe, setnameCafe] = useState(null);
    const [nameDriver4x4, setnameDriver4x4] = useState(null);
    const [nameDriverSedan, setnameDriverSedan] = useState(null);
    const [nameDriver4x4Other, setnameDriver4x4Other] = useState(null);
    const [nameDriverBus, setnameDriverBus] = useState(null);
    const [nameCars, setnameCars] = useState(null);
    
    const [tours, setTours] = useState([]);
    const [company, setCompany] = useState([]);
    const [guide, setGuide] = useState([]);
    const [cafe, setCafe] = useState([]);
    const [driver4x4, setDriver4x4] = useState([]);
    const [driverSedan, setDriverSedan] = useState([]);
    const [driverDriver4x4Other, setDriver4x4Other] = useState([]);
    const [driverBus, setDriverBus] = useState([]);
    const [cars, setCars] = useState([]);

    const optionsCars = cars.map((i) => ({ value: i.id, label: i.name }));
    const addresursforminputtour = document.querySelector(".addresurs-form-inputtour");
    const addresursformcompany = document.querySelector(".addresurs-form-inputcompany");
    const addresursforminputguide = document.querySelector(".addresurs-form-inputguide");
    const addresursforminputcafe = document.querySelector(".addresurs-form-inputcafe");
    const addresursforminputdriver4x4 = document.querySelector(".addresurs-form-inputdriver4x4");
    const addresursforminputdriver4x4Other = document.querySelector(".addresurs-form-inputdriver4x4Other");
    const addresursforminputdriverSedan = document.querySelector(".addresurs-form-inputdriverSedan");
    const addresursforminputdriverBus = document.querySelector(".addresurs-form-inputdriverBus");
    const addresursforminputCars = document.querySelector(".addresurs-form-inputCars");
    const addresursformcompanyinn = document.querySelector(".addresurs-form-inputcompanyinn");
    /////////////////////////////////////////////
    const getTours = async () => {
        const res = await axios.post(`${API_URL}/getTours`);
        setTours(res.data);
    }
    const addTours = async () => {
        await axios.post(`${API_URL}/addTours`, { nameTours, role: user.role, subroles: user.subroles, });
        addresursforminputtour.value = "";
        getTours();
    }
    const deleteTours = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteTours`, { id, role: user.role, subroles: user.subroles })
        getTours();
    };
    /////////////////////////////////////////////
    const getCompany = async () => {
        const res = await axios.post(`${API_URL}/getCompany`);
        setCompany(res.data)
    }
    const addCompany = async () => {
        try {
            const res = await axios.post(`${API_URL}/addCompany`, { nameCompany, innCompany, role: user.role, subroles: user.subroles, });

            if (res.data.status === "success") {
                addresursformcompany.value = "";
                addresursformcompanyinn.value = "";
                setInnCompany("");
                getCompany();
            } else {
                alert(res.data.message);
            }

        } catch (err) {
            console.log(err);
            alert("Ошибка сервера");
        }
    };
    const deleteCompany = async (id) => {
        const confirmDelete = window.confirm("Удалить?");

        if (!confirmDelete) return;

        await axios.post(`${API_URL}/deleteCompany`, { id, role: user.role, subroles: user.subroles, });
        getCompany();
    };
    const updateCompanyInn = async (id, inn) => {
        try {
            await axios.post(`${API_URL}/updateCompanyInn`, { id, inn, role: user.role, subroles: user.subroles });
        } catch (err) {
            console.log(err);
            alert("Не удалось сохранить ИНН");
        }
    };
    ///////////////////////////////////////////////////
    const getGuide = async () => {
        const res = await axios.post(`${API_URL}/getGuide`);
        setGuide(res.data);
    }
    const addGuide = async () => {
        try {
            const res = await axios.post(`${API_URL}/addGuide`, { nameGuide, role: user.role, subroles: user.subroles, });
            if (res.data.status === "success") {
                addresursforminputguide.value = "";
                getGuide();
            }
            else {
                alert(res.data.message)
            }
        }
        catch (err) {
            console.log(err);
            alert("Ошибка сервера")

        }
    }
    const deleteGuide = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteGuide`, { id, role: user.role, subroles: user.subroles })
        getGuide();
    };
    //////////////////////////////////////////////
    const getCafe = async () => {
        const res = await axios.post(`${API_URL}/getCafe`);
        setCafe(res.data);
    }
    const addCafe = async () => {
        try {
            const res = await axios.post(`${API_URL}/addCafe`, { nameCafe, role: user.role, subroles: user.subroles, });
            if (res.data.status === "success") {
                addresursforminputcafe.value = "";
                getCafe();
            }
            else {
                alert(res.data.message)
            }
        }
        catch (err) {
            console.log(err);
            alert("Ошибка сервера")

        }
    }
    const deleteCafe = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteCafe`, { id, role: user.role, subroles: user.subroles })
        getCafe();
    };
    //////////////////////////////////////////////
    const getDriver4x4 = async () => {
        const res = await axios.post(`${API_URL}/getDriver4x4`);
        setDriver4x4(res.data);
    }
    const addDriver4x4 = async () => {
        try {
            const res = await axios.post(`${API_URL}/addDriver4x4`, { nameDriver4x4, role: user.role, subroles: user.subroles, });
            if (res.data.status === "success") {
                addresursforminputdriver4x4.value = "";
                getDriver4x4();
            }
            else {
                alert(res.data.message)
            }
        }
        catch (err) {
            console.log(err);
            alert("Ошибка сервера")

        }
    }
    const deleteDriver4x4 = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteDriver4x4`, { id, role: user.role, subroles: user.subroles })
        getDriver4x4();
    };
    const setDriverCar = async (driverId, carId) => {
        try {
            const res = await axios.post(`${API_URL}/setDriverCar`, {
                driverId,
                carId,
                role: user.role,
                subroles: user.subroles,
            });
            if (res.data.status === "error") {
                alert(res.data.message);
            }
            getDriver4x4();
        } catch (err) {
            console.log(err);
            alert("Ошибка сервера");
        }
    };
    //////////////////////////////////////////////
    const getDriver4x4Other = async () => {
        const res = await axios.post(`${API_URL}/getDriver4x4Other`);
        setDriver4x4Other(res.data);
    }
    const addDriver4x4Other = async () => {
        try {
            const res = await axios.post(`${API_URL}/addDriver4x4Other`, { nameDriver4x4Other, role: user.role, subroles: user.subroles, });
            if (res.data.status === "success") {
                addresursforminputdriver4x4Other.value = "";
                getDriver4x4Other();
            }
            else {
                alert(res.data.message)
            }
        }
        catch (err) {
            console.log(err);
            alert("Ошибка сервера")

        }
    }
    const deleteDriver4x4Other = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteDriver4x4Other`, { id, role: user.role, subroles: user.subroles })
        getDriver4x4Other();
    };
    //////////////////////////////////////////////
    const getDriverSedan = async () => {
        const res = await axios.post(`${API_URL}/getDriverSedan`);
        setDriverSedan(res.data);
    }
    const addDriverSedan = async () => {
        try {
            const res = await axios.post(`${API_URL}/addDriverSedan`, { nameDriverSedan, role: user.role, subroles: user.subroles, });
            if (res.data.status === "success") {
                addresursforminputdriverSedan.value = "";
                getDriverSedan();
            }
            else {
                alert(res.data.message)
            }
        }
        catch (err) {
            console.log(err);
            alert("Ошибка сервера")

        }
    }
    const deleteDriverSedan = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteDriverSedan`, { id, role: user.role, subroles: user.subroles })
        getDriverSedan();
    };
    //////////////////////////////////////////////
    const getDriverBus = async () => {
        const res = await axios.post(`${API_URL}/getDriverBus`);
        setDriverBus(res.data);
    }
    const addDriverBus = async () => {
        try {
            const res = await axios.post(`${API_URL}/addDriverBus`, { nameDriverBus, role: user.role, subroles: user.subroles, });
            if (res.data.status === "success") {
                addresursforminputdriverBus.value = "";
                getDriverBus();
            }
            else {
                alert(res.data.message)
            }
        }
        catch (err) {
            console.log(err);
            alert("Ошибка сервера")

        }
    }
    const deleteDriverBus = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteDriverBus`, { id, role: user.role, subroles: user.subroles })
        getDriverBus();
    };
    //////////////////////////////////////////////
    const getCars = async () => {
        const res = await axios.post(`${API_URL}/getCars`);
        setCars(res.data);
    }
    const addCars = async () => {
        try {
            const res = await axios.post(`${API_URL}/addCars`, { nameCars, role: user.role, subroles: user.subroles, });
            if (res.data.status === "success") {
                addresursforminputCars.value = "";
                getCars();
            }
            else {
                alert(res.data.message)
            }
        }
        catch (err) {
            console.log(err);
            alert("Ошибка сервера")

        }
    }
    const deleteCars = async (id) => {
        const confirmDelete = window.confirm("Удалить?");
        if (!confirmDelete) return;
        await axios.post(`${API_URL}/deleteCars`, { id, role: user.role, subroles: user.subroles })
        getCars();
    };

    /////////////////////////////////////////////////

    useEffect(() => {
        getTours();
        getCompany();
        getGuide();
        getCafe();
        getDriver4x4();
        getDriverSedan();
        getDriverBus();
        getCars();
        getDriver4x4Other();
    }, []);
    return (
        <div className="addresurs">
            <div className="addresurs-box">
                <h2>Программа</h2>
                <div className="addresurs-list">
                    {tours.map((item) => (
                        <div className="addresurs-item" key={item.id}>
                            <span>{item.id}</span>

                            <span>{item.name}</span>

                            <button
                                className="delete-btn"
                                onClick={() => deleteTours(item.id)}
                            >
                                <i class="fa-solid fa-trash-can"></i>
                            </button>
                        </div>
                    ))}
                </div>

                <div className="addresurs-form">
                    <input className="addresurs-form-inputtour"
                        placeholder="Название тура"
                        onChange={(e) => setnameTours(e.target.value)}
                    />
                    <button onClick={addTours}>
                        +
                    </button>
                </div>

            </div>
            <div className="addresurs-box">
                <h2>Компании</h2>
                <div className="addresurs-list">
                    {[...company]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => (
                            <div className="addresurs-item" key={item.id}>
                                <span>{item.id}</span>
                                <span>{item.name}</span>
                                <input
                                    className="addresurs-inn-input"
                                    placeholder="ИНН"
                                    defaultValue={item.inn || ""}
                                    onBlur={(e) => updateCompanyInn(item.id, e.target.value)}
                                />

                                <button
                                    className="delete-btn"
                                    onClick={() => deleteCompany(item.id)}
                                >
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                            </div>
                        ))}
                </div>

                <div className="addresurs-form">
                    <input className="addresurs-form-inputcompany"
                        placeholder="Название Компании"
                        onChange={(e) => setnameCompany(e.target.value)}
                    />
                    <input className="addresurs-form-inputcompanyinn"
                        placeholder="ИНН"
                        onChange={(e) => setInnCompany(e.target.value)}
                    />
                    <button onClick={addCompany}>
                        +
                    </button>
                </div>

            </div>
            <div className="addresurs-box">
                <h2>Гид</h2>
                <div className="addresurs-list">
                    {[...guide]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => (
                            <div className="addresurs-item" key={item.id}>
                                <span>{item.id}</span>
                                <span>{item.name}</span>

                                <button
                                    className="delete-btn"
                                    onClick={() => deleteGuide(item.id)}
                                >
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                            </div>
                        ))}
                </div>

                <div className="addresurs-form">
                    <input className="  addresurs-form-inputguide"
                        placeholder="Название Компании"
                        onChange={(e) => setnameGuide(e.target.value)}
                    />
                    <button onClick={addGuide}>
                        +
                    </button>
                </div>

            </div>
            <div className="addresurs-box">
                <h2>Кафе</h2>
                <div className="addresurs-list">
                    {[...cafe]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => (
                            <div className="addresurs-item" key={item.id}>
                                <span>{item.id}</span>
                                <span>{item.name}</span>

                                <button
                                    className="delete-btn"
                                    onClick={() => deleteCafe(item.id)}
                                >
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                            </div>
                        ))}
                </div>

                <div className="addresurs-form">
                    <input className="  addresurs-form-inputcafe"
                        placeholder="Название Компании"
                        onChange={(e) => setnameCafe(e.target.value)}
                    />
                    <button onClick={addCafe}>
                        +
                    </button>
                </div>

            </div>

            <div className="addresurs-box">
                <h2>Водитель Седан</h2>
                <div className="addresurs-list">
                    {[...driverSedan]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => (
                            <div className="addresurs-item" key={item.id}>
                                <span>{item.id}</span>
                                <span>{item.name}</span>

                                <button
                                    className="delete-btn"
                                    onClick={() => deleteDriverSedan(item.id)}
                                >
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                            </div>
                        ))}
                </div>

                <div className="addresurs-form">
                    <input className="  addresurs-form-inputdriverSedan"
                        placeholder="Название Компании"
                        onChange={(e) => setnameDriverSedan(e.target.value)}
                    />
                    <button onClick={addDriverSedan}>
                        +
                    </button>
                </div>
            </div>
            <div className="addresurs-box">
                <h2>Водитель (Микро)Автобус</h2>
                <div className="addresurs-list">
                    {[...driverBus]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => (
                            <div className="addresurs-item" key={item.id}>
                                <span>{item.id}</span>
                                <span>{item.name}</span>

                                <button
                                    className="delete-btn"
                                    onClick={() => deleteDriverBus(item.id)}
                                >
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                            </div>
                        ))}
                </div>

                <div className="addresurs-form">
                    <input className="  addresurs-form-inputdriverBus"
                        placeholder="Название Компании"
                        onChange={(e) => setnameDriverBus(e.target.value)}
                    />
                    <button onClick={addDriverBus}>
                        +
                    </button>
                </div>
            </div>
            <div className="addresurs-box">
                <h2>Наши Водители 4х4</h2>
                <div className="addresurs-list">
                    {[...driver4x4]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => {
                            const busyByOthers = driver4x4
                                .filter((d) => d.id !== item.id && d.carid)
                                .map((d) => d.carid);

                            const availableOptions = optionsCars.filter(
                                (opt) => !busyByOthers.includes(opt.value)
                            );

                            const selectedOption =
                                optionsCars.find((opt) => opt.value === item.carid) || null;

                            return (
                                <div className="addresurs-item" key={item.id}>
                                    <span>{item.id}</span>
                                    <span>{item.name}</span>
                                    <Select
                                        options={availableOptions}
                                        value={selectedOption}
                                        isClearable
                                        onChange={(selected) =>
                                            setDriverCar(item.id, selected ? selected.value : null)
                                        }
                                        placeholder="Выберите авто"
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                    />
                                    <button
                                        className="delete-btn"
                                        onClick={() => deleteDriver4x4(item.id)}
                                    >
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            );
                        })}
                </div>

                <div className="addresurs-form">
                    <input className="  addresurs-form-inputdriver4x4"
                        placeholder="Название Компании"
                        onChange={(e) => setnameDriver4x4(e.target.value)}
                    />
                    <button onClick={addDriver4x4}>
                        +
                    </button>
                </div>

            </div>

            <div className="addresurs-box">
                <h2>Автомобили 4x4</h2>
                <div className="addresurs-list">
                    {[...cars]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => {
                            const isBusy = driver4x4.some((d) => d.carid === item.id);

                            return (
                                <div
                                    className={`addresurs-item${isBusy ? " car-busy" : " car-unbusy"}`}
                                    key={item.id}
                                >
                                    <span>{item.id}</span>
                                    <span>{item.name}</span>

                                    <button
                                        className="delete-btn"
                                        onClick={() => deleteCars(item.id)}
                                    >
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            );
                        })}
                </div>

                <div className="addresurs-form">
                    <input className="  addresurs-form-inputCars"
                        placeholder="Название Компании"
                        onChange={(e) => setnameCars(e.target.value)}
                    />
                    <button onClick={addCars}>
                        +
                    </button>
                </div>
            </div>
            <div className="addresurs-box">
                <h2>Левые Водители 4x4</h2>
                <div className="addresurs-list">
                    {[...driverDriver4x4Other]
                        .sort((a, b) => a.id - b.id)
                        .map((item) => (
                            <div className="addresurs-item" key={item.id}>
                                <span>{item.id}</span>
                                <span>{item.name}</span>

                                <button
                                    className="delete-btn"
                                    onClick={() => deleteDriver4x4Other(item.id)}
                                >
                                    <i class="fa-solid fa-trash-can"></i>
                                </button>
                            </div>
                        ))}
                </div>

                <div className="addresurs-form">
                    <input className="  addresurs-form-inputdriver4x4Other"
                        placeholder="Название Компании"
                        onChange={(e) => setnameDriver4x4Other(e.target.value)}
                    />
                    <button onClick={addDriver4x4Other}>
                        +
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddResurs;